import { _t } from '@/locale';

/**
 * Sentinel employee id meaning "no specific employee — any available one will do", the
 * value `state.book.employee` carries for a "Valfri utövare" selection and the value the
 * `sr` query param serialises to. Compare against this rather than falsy-checking the id:
 * `0` is falsy, so `if (!employeeId)` cannot tell "any employee" from "nothing picked".
 */
export const ANY_EMPLOYEE_ID = 0;

export const getAnyEmployee = () => ({
  id: ANY_EMPLOYEE_ID,
  about: {
    name: _t('features.bookingSelection.anyEmployee'),
    jobTitle: _t('features.bookingSelection.anyEmployeeHint'),
  },
});
